import { cn } from '../../utils/cn'

interface Props {
  readonly text: string
  readonly size?: 'sm' | 'md'
}

const SIZE: Readonly<Record<'sm' | 'md', string>> = {
  sm: 'w-9 h-9 text-xs',
  md: 'w-12 h-12 text-sm',
}

/**
 * Initials avatar — accent fill, white text, single shared shape
 * so customer chips line up across the app.
 */
export function Avatar({ text, size = 'md' }: Props) {
  return (
    <div
      className={cn(
        'rounded-full bg-accent text-white grid place-items-center font-extrabold shrink-0',
        SIZE[size],
      )}
    >
      {text}
    </div>
  )
}

/** Helper — first letter of first two name parts, uppercased. */
export function nameInitials(name: string): string {
  return name
    .split(/\s+/)
    .map((p) => p[0] ?? '')
    .slice(0, 2)
    .join('')
    .toUpperCase()
}
